import { render, staticRenderFns } from "./ProfileFeatures.vue?vue&type=template&id=f4785830&scoped=true"
import script from "./ProfileFeatures.vue?vue&type=script&lang=js"
export * from "./ProfileFeatures.vue?vue&type=script&lang=js"
import style0 from "./ProfileFeatures.vue?vue&type=style&index=0&id=f4785830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4785830",
  null
  
)

export default component.exports